export const isGyroscopeEnabled = state => state.getIn(['device', 'isGyroscopeEnabled'])
